import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "./Reveal";

export function ComparisonTable({ data, caption }) {
  const { lang } = useLang();
  const head = lang === "de" ? data.head.de : data.head.en;
  return (
    <Reveal>
      <div className="overflow-x-auto rounded-2xl border border-[#e4e9f0]" data-testid="comparison-table">
        <table className="w-full min-w-[640px] border-collapse text-left">
          {caption && <caption className="sr-only">{caption}</caption>}
          <thead>
            <tr className="bg-[#16181D] text-white">
              {head.map((h, i) => (
                <th key={i} className={`px-5 py-4 font-head text-sm font-semibold ${i === 1 ? "text-[#F0A26A]" : ""}`}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((r, i) => {
              const cells = lang === "de" ? r.de : r.en;
              return (
                <tr key={i} className={i % 2 ? "bg-[#f6f8fb]" : "bg-white"}>
                  {cells.map((c, j) => (
                    <td key={j} className={`px-5 py-4 text-sm ${j === 0 ? "font-medium text-[#16181D]" : "text-[#4a4d52]"}`}>{c}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Reveal>
  );
}
